import type { MessageDescriptorV2 } from '@atlassian/jira-intl/src/v2/types.tsx';
import { MAX_DESCRIPTION_LENGTH } from '../../common/ui/constants';
import type { CreateOrEditPriorityScheme } from '../../common/ui/types';
import messages from '../messages';

const nameField = 'name';
const prioritiesField = 'priorityIds';

export type OnError = (
	field: 'name' | 'description' | 'priorityIds',
	messageDescriptor: MessageDescriptorV2,
	optionalValues?: Record<string, number> | undefined,
) => void;

export const validateName = (name: string, onError?: OnError): boolean => {
	if (name.length === 0) {
		onError && onError(nameField, messages.prioritySchemeNameFieldEmptyValidationError);
		return false;
	}
	return true;
};

export const validateDescription = (description: string): boolean => {
	if (description.length >= MAX_DESCRIPTION_LENGTH) {
		return false;
	}
	return true;
};

export const validatePriorities = (
	priorities: CreateOrEditPriorityScheme['priorities'],
	onError?: OnError,
): boolean => {
	if (priorities.length === 0) {
		onError && onError(prioritiesField, messages.prioritySchemePrioritiesFieldEmptyValidationError);
		return false;
	}
	return true;
};
